import { useContext } from 'react';
import { AnalyticsContext } from '../analytics-provider/AnalyticsContext';

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useAnalytics = () => useContext(AnalyticsContext);
